import TimersListingController from './Listing/TimersListingController'
import { MyTimersListingContainer } from './styledComponents'

export default function MyTimersListing() {
  return (
    <MyTimersListingContainer>
      <TimersListingController />
    </MyTimersListingContainer>
  )
}
